import React from 'react'

import productStyle from 'assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx'
import withStyles from '@material-ui/core/styles/withStyles'
import AttachMoney from '@material-ui/icons/AttachMoney'
import BusinessCenter from '@material-ui/icons/BusinessCenter'
import CreditCard from '@material-ui/icons/CreditCard'

import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import InfoArea from 'components/InfoArea/InfoArea.jsx'

const SessionNotes = ({ classes }) => (
    <div className={classes.section}>
        <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
                <h2 className={classes.title}>Billing and Insurance</h2>
                <h5 className={classes.description}>
          Possibly the worst part of any business - the paperwork. Don't worry,
          we'll take care of that for you.
                </h5>
            </GridItem>
        </GridContainer>
        <div>
            <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                    <InfoArea
                        title="Generate Insurance Claims"
                        description="We automatically generate insurance claims for patients after visits and send them to the appropriate place. All you need to do is fill in the insurance information during intake."
                        icon={BusinessCenter}
                        iconColor="success"
                        vertical
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                    <InfoArea
                        title="Integrate With Cloud Accounting"
                        description="A user of QuickBooks Online or FreshBooks? If so, you have to be careful what to put in there since they are not HIPAA Compliant. We can integrate with them and provide summaries of your finances automatically and safely."
                        icon={AttachMoney}
                        iconColor="info"
                        vertical
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                    <InfoArea
                        title="Collect Payment"
                        description="Whatever insurance doesn't cover, we can help you collect with card payment processing for no additional charge."
                        icon={CreditCard}
                        iconColor="warning"
                        vertical
                    />
                </GridItem>
            </GridContainer>
        </div>
    </div>
)

export default withStyles(productStyle)(SessionNotes)



// WEBPACK FOOTER //
// ./src/views/Features/PracticeManagement/Sections/BillingIntegrations.jsx